import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  SET_PLAN_PERIOD_TYPE,
  SET_SUBSCRIPTION_PLANS,
  SET_USER_AND_PLAN_DETAILS,
  SET_IS_LOADING,
} from "../../../actions/types";
import IdeaIcon from "../../../assets/icons/idea_icon.svg";
import {
  Row,
  Col
} from "reactstrap";
import ToolTip from "../../events/Components/Common/ToolTip";
import ConfirmPaymentModal from "./confirm-payment-modal";
import CancelPlanModal from "./cancel-plan-modal";
import PlanDetailModal from "./plan-detail-modal";
import isEmpty from "../../../validation/is-empty";
import CardInfoModal from "./card-info-modal";
import { notification } from "../../../utils/utility";
import axiosInstance from "../../../axios-instance";
import Loader from "../../../components/Loader/Loader";
import UpdateCardModal from "./update-card-modal";

const SubscriptionPlans = (props) => {
  const dispatch = useDispatch();

  const [showCardInfoModal, setShowCardInfoModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingSentence, setLoadingSentence] = useState(null);
  const [showChangeCardModal, setShowChangeCardModal] = useState(false);
  const { plans, planPeriodType, userPlan } = props.subscription;
  
  /**
   * swap elements of array
   * @param array arr
   * @param int index1
   * @param int index2
   */
  const swapElements = (arr, index1, index2) => {
    let temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
  };

  /**
   * toggle checkbox status
   * @param mixed event
   * @param int planId
   */
  const toggleIndividualOrTeamStatus = (event, planId) => {
    const appPlans = [...props.subscription.plans];
    planId = parseInt(planId);
    if (planId === 1 || planId === 4) {
      swapElements(appPlans, 0, 3);
    } else if (planId === 2 || planId === 5) {
      swapElements(appPlans, 1, 4);
    } else {
      swapElements(appPlans, 2, 5);
    }
    dispatch({
      type: SET_SUBSCRIPTION_PLANS,
      payload: appPlans,
    });
  };

  /**
   * on cancel plan
   * @param {*} reason
   * @param {*} natureOfIssue
   * @param {*} preferredContact
   */
  const onCancelSubscription = async (reason, natureOfIssue, preferredContact) => {
    const { getUserAndPlans } = props;

    dispatch({
      type: SET_IS_LOADING,
      payload: true,
    });

    const res = await axiosInstance.post("/admin/subscription/cancel", {});

    dispatch({
      type: SET_IS_LOADING,
      payload: false,
    });
    if (res.data.success) {
      notification.success(res.data.message);
      setLoadingSentence("Please wait, your subscription is being cancelled. This may take a few moments.");
      setIsLoading(true);
      setTimeout(() => {
        getUserAndPlans();
        setIsLoading(false);
      }, 15000);
    } else {
      notification.error(res.data.message);
    }
  };

  /**
   * upgrade plan handler
   * @param {*} data
   */
  const upgradePlanHandler = async (data) => {
    const { getUserAndPlans } = props;
    const { selectedPlan, planPeriodType } = props.subscription;

    dispatch({
      type: SET_IS_LOADING,
      payload: true,
    });

    const res = await axiosInstance.post("/admin/subscription/update", {
      plan_id: selectedPlan.id,
      plan_type: planPeriodType
    });

    dispatch({
      type: SET_IS_LOADING,
      payload: false,
    });
    if (res.data.success) {
      notification.success(res.data.message);
      setLoadingSentence("Please wait, your subscription is being updated. This may take a few moments.");
      setIsLoading(true);
      setTimeout(() => {
        getUserAndPlans();
        setIsLoading(false);
      }, 15000);
    } else {
      notification.error(res.data.message);
    }
  };

  /**
   * on upgrade plan, in case you are moving from free plan to paid
   * @param {*} plan
   */
  const onUpgradePlan = (plan) => {
    setShowCardInfoModal(true);
    dispatch({
      type: SET_USER_AND_PLAN_DETAILS,
      payload: {
        selectedPlan: plan,
      },
    });
  };

  const isTeamPlan = userPlan?.plan_type === "team";

  return (
    <>
      {/* Monthly Anullay Switch */}
      <Loader isShowLoader={isLoading} loadingText={loadingSentence} />
      {showChangeCardModal && <UpdateCardModal toggle={setShowChangeCardModal}/>}
      <div className="mb-4 d-flex justify-content-center align-items-center">
        <label className="form-check-label mb-0">Monthly</label>
        <div className="toggle_field mx-2">
          <div className="box_content bg-transparent p-0">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                checked={props.subscription.planPeriodType === "annual"}
                onChange={(event) => {
                  dispatch({
                    type: SET_PLAN_PERIOD_TYPE,
                    payload: event.target.checked ? "annual" : "monthly",
                  });
                }}
              />
            </div>
          </div>
        </div>
        <label className="form-check-label mb-0">Annually</label>
        {userPlan.is_paid_subscription === "E" && (
          <div class="d-flex justify-content-end mr-4">
          <button className="btn btn_success btn-14" style={{width:"auto"}}
            onClick={() => setShowChangeCardModal(true)}>
              Change Card
          </button>
          </div>
        )}
        {userPlan.is_paid_subscription === "E" && (
          <CancelPlanModal cancelPlan={onCancelSubscription} />
        )}
      </div>
      {/* Annual Subscription Benefit */}
      <div className="cmplt_prof_msg subscription_msg">
        <img src={IdeaIcon} alt="Alert Icon" />{" "}
        <p>
          You Can Save <span>$50</span> On Annually Subscription
        </p>
      </div>
      <Row className="pt-2">
        {showCardInfoModal && (
          <CardInfoModal
            getUserAndPlans={props.getUserAndPlans}
            setShowCardInfoModal={setShowCardInfoModal}
            selectedPlan={props.subscription.selectedPlan}
            planPeriodType={props.subscription.planPeriodType}
          />
        )}
        {plans
          .filter((plan, planIndex) => isTeamPlan ? planIndex >= 3 : planIndex < 3)
          .map((plan, index) => {
            return (
              <Col lg="4" md="6" key={index}>
                <div className="subscription_card">
                  <div className="cd_head">
                    <h3>
                      {plan.plan_name}{" "}
                      <label>
                        {planPeriodType === "monthly" ? (
                          <>(Monthly)</>
                        ) : (
                          <>(Annually)</>
                        )}
                      </label>
                      <ToolTip />
                    </h3>
                    <div className="w-auto d-flex justify-content-center align-items-center">
                      <label className="form-check-label mb-0">
                        Individual
                      </label>
                      <div className="toggle_field mx-2">
                        <div className="box_content bg-transparent p-0">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={plan.plan_type === "team"}
                              onChange={(event) =>
                                toggleIndividualOrTeamStatus(event, plan.id)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <label className="form-check-label mb-0">Organizations</label>
                    </div>
                  </div>
                  <div className="cd_body">
                    <p>
                      Start automating basic scheduling features
                      <span>
                        $
                        {planPeriodType === "monthly"
                          ? plan.monthly_price
                          : plan.annual_price}
                        .00
                      </span>
                    </p>

                    {/* Plan Price */}
                    <h2>
                      <span>
                        $
                        {planPeriodType === "monthly"
                          ? plan.monthly_price
                          : plan.annual_price}
                        .00
                      </span>
                    </h2>

                    <div className="d-flex flex-wrap justify-content-between">
                      <PlanDetailModal />
                      {plan.id === userPlan.plan_id ? (
                        <button className="btn btn_success">Active</button>
                      ) : (
                        <>
                          {/* Already paid subscription */}
                          {userPlan.is_paid_subscription === "E" ? (
                            <>
                              <ConfirmPaymentModal
                                price={
                                  planPeriodType === "monthly"
                                    ? plan.monthly_price
                                    : plan.annual_price
                                }
                                plan_id={plan.id}
                                plan={plan}
                                planPeriodType={planPeriodType}
                                userCurrentPlan={userPlan}
                                upgradePlan={upgradePlanHandler}
                              />
                            </>
                          ) : (
                            <>
                              {/* Go to Payment Page */}
                              {
                                ((planPeriodType === "monthly" && plan.monthly_price > userPlan.monthly_price) ||
                                (planPeriodType === "annual" && plan.annual_price > userPlan.annual_price) ||
                                  isEmpty(userPlan.plan_id)) ? (
                                <button
                                  className="btn btn-outline brand"
                                  onClick={() => onUpgradePlan(plan)}
                                >
                                  Upgrade Plan
                                </button>
                              ) : (
                                <button 
                                className="btn btn-outline brand"
                                onClick={() => onUpgradePlan(plan)}
                                >
                                  Downgrade Plan
                                </button>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            );
          })}
      </Row>
    </>
  );
};

const mapStateToProps = (state) => ({
  subscription: state.subscription,
});

export default connect(mapStateToProps, null)(SubscriptionPlans);
